import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  changeChat,
  createNewChatAsync,
} from "../../../../../../ReduxToolkit/Reducers/ChatReducer";
import { Image, LI, P, UL } from "../../../../../../AbstractElements";
import { dynamicImage } from "../../../../../../Utils";
import { formatDistanceToNow, parse } from "date-fns";
import { getUserID } from "../../../../../../services/helper";
import ContactEdit from "./ContactEdit";

export default function ChatTabPane() {
  const { members, currentUser, selectedUser, chats } = useSelector(
    (state) => state.chat
  );
  const [Open, setOpen] = useState(false);
  const toggle = () => {
    setOpen(!Open);
  };
  const current_user_id = getUserID();

  const dispatch = useDispatch();
  const activeChat = selectedUser && selectedUser[0] ? selectedUser[0].id : 0;

  const membersWithChats = members
    .filter(
      (member) =>
        member.id !== Number(current_user_id) && // Exclude the current user
        chats.some((chat) => chat.users.includes(member.id))
    )
    .sort((a, b) => {
      const chatA = chats.find((chat) => chat.users.includes(a.id));
      const chatB = chats.find((chat) => chat.users.includes(b.id));
      const timeA = chatA?.lastMessageTime
        ? new Date(`1970/01/01 ${chatA.lastMessageTime}`).getTime()
        : 0;
      const timeB = chatB?.lastMessageTime
        ? new Date(`1970/01/01 ${chatB.lastMessageTime}`).getTime()
        : 0;
      return timeB - timeA;
    });

  const membersWithoutChats = members.filter(
    (member) =>
      !membersWithChats.some((m) => m.id === member.id) &&
      member.id !== currentUser.id
  );

  const changeChatClick = (selectedUserId) => {
    const currentUserId = currentUser.id;
    const currentChat = chats.find(
      (x) =>
        x.users.includes(currentUser.id ?? 0) &&
        x.users.includes(selectedUserId)
    );
    if (currentChat) {
      dispatch(changeChat(selectedUserId));
    } else {
      dispatch(createNewChatAsync({ currentUserId, selectedUserId, chats }));
    }
  };

  const formatLastMessageTime = (time) => {
    // console.log(time);
    if (!time || time === "-") return "";
    const parsedTime = parse(time, "hh:mm a", new Date());
    return formatDistanceToNow(parsedTime, { addSuffix: false });
  };

  return (
    <>
      {chats && chats.length > 0 ? (
        <UL className="chats-user simple-list">
          {[...membersWithChats].map((item, i) => {
            const chat = chats.find((chat) => chat.users.includes(item.id));
            const lastMessageTime = chat
              ? formatLastMessageTime(chat.lastMessageTime)
              : null;

            return (
              <LI
                key={i}
                className={`common-space ${
                  activeChat === item.id ? "active" : ""
                }`}
                onClick={() => changeChatClick(item.id)}
              >
                <div className="chat-time">
                  <div className="active-profile">
                    <Image
                      src={
                        item.image ? item.image : dynamicImage("avtar/3.jpg")
                      }
                      className="img-fluid rounded-circle"
                      alt=""
                    />
                    <div
                      className={`status bg-${
                        item.online ? "success" : "warning"
                      }`}
                    ></div>
                  </div>
                  <div>
                    <span>{item.name}</span>
                    {item.store_name && (
                      <span>
                        {" "}
                        <strong>({item.store_name})</strong>
                      </span>
                    )}
                  </div>

                  <div>
                    <P>{lastMessageTime}</P>
                  </div>

                  <ContactEdit
                    className={"ml-auto"}
                    id={chat?.id}
                    sender={chat?.Sender}
                    recipient={chat?.Recipient}
                  />
                </div>
              </LI>
            );
          })}
        </UL>
      ) : (
        <div className="text-center">{"No Chat Present"}</div>
      )}
    </>
  );
}
